function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { themify, shade } from '../styles/mixins';
import { shimmer } from '../styles/animations';
import { Card } from './Card';
import { Icon } from './Icon';
import { Spacer } from './Spacer';
import { Small } from './helpers/FontSize';
import CancelCircle from '../icons/solid/CancelCircle';
import withSpacing from '../lib/hoc/withSpacing';
const StyledPlaceholder = styled(Card).withConfig({
  displayName: "Placeholder__StyledPlaceholder",
  componentId: "ydp814-0"
})(["position:relative;height:", ";width:", ";animation-duration:1.8s;animation-fill-mode:both;animation-iteration-count:infinite;animation-name:", ";animation-timing-function:linear;line-height:", ";color:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;", ";background-size:", ";&:hover{overflow:visible;white-space:pre-wrap;}"], x => x.$height, x => x.$width, shimmer, x => x.$lineHeight, x => x.$error ? themify('red') : 'inherit', x => !x.$error && css(["background:", ";"], y => `linear-gradient(to right, ${themify(y.$bgColor)} 8%,
        ${shade(0.97, themify(y.$bgColor))} 38%, ${themify(y.$bgColor)} 54%)`), x => `calc(2 * ${x.$width}) ${x.$height}`);

const PlaceholderFunc = (_ref) => {
  let {
    bgColor = 'white',
    className,
    error,
    fontSize = 5,
    height = '3em',
    lineHeight = 1,
    shadow = 'none',
    width = '100%'
  } = _ref,
      cardProps = _objectWithoutProperties(_ref, ["bgColor", "className", "error", "fontSize", "height", "lineHeight", "shadow", "width"]);

  if (error) console.error(error);
  return /*#__PURE__*/React.createElement(StyledPlaceholder, _extends({
    animation: "none",
    className: className,
    $bgColor: bgColor,
    $error: Boolean(error),
    $fontSize: fontSize,
    $height: height,
    $lineHeight: lineHeight,
    $shadow: shadow,
    $width: width
  }, cardProps), error && /*#__PURE__*/React.createElement(Small, null, /*#__PURE__*/React.createElement(Icon, {
    icon: CancelCircle,
    solid: true,
    fill: "red",
    mr: 2
  }), " ", /*#__PURE__*/React.createElement(Spacer, null), " ", error.message));
};

export const Placeholder = withSpacing(PlaceholderFunc, {
  mb: 2
});